// Handle of upsell dropdown for changing input value
document.addEventListener('upsell:variantChange', (event) => {
  const selectedOption = event.detail.target.options[event.detail.target.selectedIndex];
  event.detail.target.nextElementSibling.value = selectedOption.value;
  event.detail.target.nextElementSibling.id = selectedOption.id;
})